export default __webpack_public_path__ + "static/media/AboutUsImage.cb382f21.jpg";